import React, { useState, useEffect } from 'react';
import { getPublicWhyUs } from '../services/api';

const WhyUs = () => {
  const [whyUsItems, setWhyUsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchWhyUsItems();
  }, []);

  const fetchWhyUsItems = async () => {
    try {
      const response = await getPublicWhyUs();
      let items = [];
      
      if (response && response.data && Array.isArray(response.data)) {
        items = response.data;
      } else if (response && Array.isArray(response)) {
        items = response;
      } else if (response && response.success && response.data && Array.isArray(response.data)) {
        items = response.data;
      }
      
      items.sort((a, b) => (a.order || 0) - (b.order || 0));
      setWhyUsItems(items);
    } catch (err) {
      console.error('Error fetching Why Us items:', err);
      setError('Failed to load Why Us items');
    } finally {
      setLoading(false);
    }
  };

  const getFullImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    if (url.startsWith('/uploads')) return `https://inteliheads.in${url}`;
    return url;
  };

  if (loading) {
    return (
      <section id="whyus" style={{ padding: '5rem 0', background: '#F7F9FC' }}>
        <div className="container">
          <div style={{ textAlign: 'center' }}>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', color: '#2C7A7B' }}></i>
            <p style={{ marginTop: '1rem', color: '#5A6E7F' }}>Loading Why Us items...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="whyus" style={{ padding: '5rem 0', background: '#F7F9FC' }}>
        <div className="container">
          <div style={{ textAlign: 'center' }}>
            <i className="fas fa-exclamation-triangle" style={{ fontSize: '2rem', color: '#DC2626' }}></i>
            <p style={{ marginTop: '1rem', color: '#DC2626' }}>{error}</p>
          </div>
        </div>
      </section>
    );
  }

  if (whyUsItems.length === 0) {
    return (
      <section id="whyus" style={{ padding: '5rem 0', background: '#F7F9FC' }}>
        <div className="container">
          <h2 style={{ fontSize: '2.25rem', marginBottom: '1rem', color: '#0A192F', textAlign: 'center' }}>
            Why INTELIHEADS INTERNET Pvt. Ltd
          </h2>
          <div style={{ fontSize: '1.125rem', color: '#5A6E7F', textAlign: 'center', marginBottom: '3rem' }}>
            Trusted by global institutions and Fortune 500 enterprises.
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            {[
              { icon: '🎯', title: 'Unmatched Expertise', description: 'Decades of combined experience in power systems, simulation, and AI engineering.' },
              { icon: '🔗', title: 'End-to-End Delivery', description: 'From concept to deployment — training, support, and lifecycle management included.' },
              { icon: '🚀', title: 'Future-Ready Technology', description: 'We partner with industry leaders to bring you the latest innovations.' },
              { icon: '🏛️', title: 'Global Presence', description: 'Offices in India, Germany, and strategic partners worldwide.' }
            ].map((reason, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2rem',
                borderRadius: '24px',
                textAlign: 'center',
                boxShadow: '0 10px 25px -5px rgba(0,0,0,0.05)',
                border: '1px solid #E2E8F0',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.borderColor = '#2C7A7B';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = '#E2E8F0';
              }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>{reason.icon}</div>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.75rem', color: '#0A192F' }}>{reason.title}</h3>
                <p style={{ color: '#5A6E7F', lineHeight: '1.6' }}>{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="whyus" style={{ padding: '5rem 0', background: '#F7F9FC' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ 
            fontSize: 'clamp(1.8rem, 5vw, 2.25rem)', 
            marginBottom: '0.5rem', 
            color: '#0A192F', 
            fontWeight: 700
          }}>
            Why <span style={{ color: '#2C7A7B' }}>INTELIHEADS</span> INTERNET Pvt. Ltd
          </h2>
          <div style={{ 
            width: '60px',
            height: '3px',
            background: '#2C7A7B',
            margin: '1rem auto',
            borderRadius: '2px'
          }} />
          <p style={{ 
            fontSize: 'clamp(1rem, 4vw, 1.125rem)', 
            color: '#5A6E7F',
            maxWidth: '700px',
            margin: '0 auto'
          }}>
            Trusted by global institutions and Fortune 500 enterprises.
          </p>
        </div>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
          gap: '2rem'
        }}>
          {whyUsItems.filter(item => item.isActive !== false).map((item, index) => (
            <div 
              key={item._id || index}
              style={{
                background: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                border: '1px solid #E2E8F0',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                e.currentTarget.style.borderColor = '#2C7A7B';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                e.currentTarget.style.borderColor = '#E2E8F0';
              }}
            >
              {/* FULL WIDTH & 1024px HEIGHT IMAGE */}
              <div style={{
                width: '100%',
                height: '1024px',
                overflow: 'hidden',
                position: 'relative',
                background: 'linear-gradient(135deg, #0A192F 0%, #1E3A5F 100%)'
              }}>
                {item.imageUrl ? (
                  <>
                    <img 
                      src={getFullImageUrl(item.imageUrl)} 
                      alt={item.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.6s ease'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `
                          <div style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            height: 100%;
                            font-size: 6rem;
                            background: linear-gradient(135deg, #2C7A7B 0%, #4A9D9E 100%);
                            color: white;
                          ">
                            ${item.icon || '⭐'}
                          </div>
                        `;
                      }}
                    />
                    
                    {/* Gradient Overlay - Strong for text visibility */}
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: '50%',
                      background: 'linear-gradient(transparent, rgba(0,0,0,0.85))'
                    }} />
                    
                    {/* Title Overlay on Image - Large & Bold */}
                    <div style={{
                      position: 'absolute',
                      bottom: '3rem',
                      left: '3rem',
                      right: '3rem',
                      color: 'white',
                      zIndex: 2
                    }}>
                      {item.icon && (
                        <span style={{ 
                          fontSize: '3.5rem', 
                          display: 'block', 
                          marginBottom: '0.5rem',
                          textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                        }}>
                          {item.icon}
                        </span>
                      )}
                      <h3 style={{
                        fontSize: '2.5rem',
                        fontWeight: 700,
                        margin: 0,
                        textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                        lineHeight: '1.2'
                      }}>
                        {item.title}
                      </h3>
                    </div>
                    
                    {/* Category Badge */}
                    <div style={{
                      position: 'absolute',
                      top: '2rem',
                      right: '2rem',
                      background: 'rgba(44,122,123,0.95)',
                      backdropFilter: 'blur(10px)',
                      padding: '0.6rem 1.5rem',
                      borderRadius: '30px',
                      fontSize: '1rem',
                      color: 'white',
                      fontWeight: 600,
                      zIndex: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                    }}>
                      <i className="fas fa-star"></i> Featured
                    </div>

                    {/* Image Info Badge */}
                    <div style={{
                      position: 'absolute',
                      bottom: '3rem',
                      right: '3rem',
                      background: 'rgba(0,0,0,0.5)',
                      backdropFilter: 'blur(10px)',
                      padding: '0.5rem 1.2rem',
                      borderRadius: '20px',
                      fontSize: '0.85rem',
                      color: 'white',
                      zIndex: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      border: '1px solid rgba(255,255,255,0.1)'
                    }}>
                      <i className="fas fa-image"></i>
                      <span>Why Us</span>
                    </div>
                  </>
                ) : (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    background: 'linear-gradient(135deg, #2C7A7B 0%, #4A9D9E 100%)',
                    color: 'white',
                    padding: '2rem',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '8rem', marginBottom: '0.5rem' }}>{item.icon || '⭐'}</div>
                    <div style={{ fontSize: '2.5rem', fontWeight: 700 }}>{item.title}</div>
                  </div>
                )}
              </div>

              {/* Content Section */}
              <div style={{ 
                padding: '1.5rem',
                flex: 1,
                display: 'flex',
                flexDirection: 'column'
              }}>
                {/* Description */}
                {item.description && (
                  <p style={{ 
                    color: '#5A6E7F', 
                    lineHeight: '1.7',
                    fontSize: '0.95rem',
                    marginBottom: '1rem'
                  }}>
                    {item.description}
                  </p>
                )}

                {/* Points/Features */}
                {item.points && item.points.length > 0 && (
                  <div style={{ marginTop: 'auto' }}>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr',
                      gap: '0.6rem'
                    }}>
                      {item.points.slice(0, 4).map((point, idx) => (
                        <div key={idx} style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '0.6rem',
                          padding: '0.6rem 0.8rem',
                          background: '#F7F9FC',
                          borderRadius: '10px',
                          borderLeft: `3px solid #2C7A7B`,
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#E6F7F5';
                          e.currentTarget.style.transform = 'translateX(4px)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#F7F9FC';
                          e.currentTarget.style.transform = 'translateX(0)';
                        }}>
                          <i className="fas fa-check-circle" style={{ color: '#10B981', fontSize: '0.9rem', marginTop: '0.15rem' }}></i>
                          <span style={{ 
                            color: '#5A6E7F', 
                            fontSize: '0.85rem',
                            lineHeight: '1.4'
                          }}>
                            {point}
                          </span>
                        </div>
                      ))}
                      {item.points.length > 4 && (
                        <div style={{ 
                          fontSize: '0.8rem', 
                          color: '#2C7A7B', 
                          textAlign: 'center',
                          padding: '0.5rem',
                          background: '#F7F9FC',
                          borderRadius: '10px',
                          fontWeight: 600
                        }}>
                          <i className="fas fa-plus-circle"></i> {item.points.length - 4} more features
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;